module.exports = __webpack_public_path__ + "img/racecourse-greyville-turf-1100.b3452e91.svg";